const EARTH_RADIUS_KM = 6371;

const toRadians = (degrees) => (degrees * Math.PI) / 180;

export function distanceInKilometres(origin, destination) {
  const originLatitude = Number(origin?.latitude);
  const originLongitude = Number(origin?.longitude);
  const destinationLatitude = Number(destination?.latitude);
  const destinationLongitude = Number(destination?.longitude);

  if (
    !Number.isFinite(originLatitude) ||
    !Number.isFinite(originLongitude) ||
    !Number.isFinite(destinationLatitude) ||
    !Number.isFinite(destinationLongitude)
  ) {
    return null;
  }

  const latitudeDifference = toRadians(destinationLatitude - originLatitude);
  const longitudeDifference = toRadians(destinationLongitude - originLongitude);
  const a =
    Math.sin(latitudeDifference / 2) ** 2 +
    Math.cos(toRadians(originLatitude)) *
      Math.cos(toRadians(destinationLatitude)) *
      Math.sin(longitudeDifference / 2) ** 2;

  return EARTH_RADIUS_KM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function sortMerchantsByDistance(merchants, customerCoordinates) {
  return merchants
    .map((merchant) => ({
      ...merchant,
      distance_km: distanceInKilometres(customerCoordinates, merchant),
    }))
    .sort((first, second) => {
      if (first.distance_km === null && second.distance_km === null) {
        return Number(second.is_featured || 0) - Number(first.is_featured || 0);
      }
      if (first.distance_km === null) return 1;
      if (second.distance_km === null) return -1;
      return first.distance_km - second.distance_km;
    });
}

export function formatDistance(distance) {
  if (!Number.isFinite(distance)) return null;
  if (distance < 1) return `${Math.max(Math.round(distance * 1000), 1)} m away`;
  return `${distance < 10 ? distance.toFixed(1) : Math.round(distance)} km away`;
}
